<div class="info-card" *ngIf="infoCard">
  <div class="main-container">
    <div class="card-container">
      <div class="card-body">
        <div *ngIf="infoCard.HasHelp" style="position: absolute;top: 0;right: 10px;">
          <app-help [helpId]="infoCard.HelpId" [placement]="left"></app-help>
        </div>
        <p class="card-title">{{infoCard.InfoCardHeaderDisplay}}</p>
        <span *ngFor="let infoCardSection of infoCard.Sections">
          <p class="card-subtitle mt-2" style="color: #44AF69;">{{infoCardSection.SectionHeaderValue}}</p>
          <p style="font-size: 13px;">{{infoCardSection.SectionContentValue}}</p>
        </span>
      </div>
    </div>
  </div>
</div>